import * as React from "react";
import * as styles from "./QuickJournalDuneHeatMirage.css";
import { QuickJournalDuneRouteField } from "./QuickJournalDuneRouteField";

export function QuickJournalDuneHeatMirage({
    isPaused = false,
}: {
    isPaused?: boolean;
}) {
    const animationPlayState: React.CSSProperties["animationPlayState"] =
        isPaused ? "paused" : "running";

    return (
        <div aria-hidden="true" className={styles.container}>
            <span
                className={styles.bottomDustSheet}
                style={{ animationPlayState }}
            />
            <QuickJournalDuneRouteField isPaused={isPaused} />
            <span
                className={`${styles.dustWisp} ${styles.dustLeft}`}
                style={{ animationPlayState }}
            />
            <span
                className={`${styles.dustWisp} ${styles.dustMidLeft}`}
                style={{ animationPlayState }}
            />
            <span
                className={`${styles.dustWisp} ${styles.dustRight}`}
                style={{ animationPlayState }}
            />
            <span
                className={`${styles.dustWisp} ${styles.dustFarRight}`}
                style={{ animationPlayState }}
            />
        </div>
    );
}
